export default __webpack_public_path__ + "static/media/File7.22fcad3b.pdf";